<template>
    <div class="ingrecient-measure-units">
        <div class="row">
            <div class="col-3">
                <label for="">Conversion</label>
            </div>
            <div class="col-6">
                <label for="">Unité</label>
            </div>
        </div>
        <div class="row" v-for="(ingredientMesaureUnit, index) in ingredientMesaureUnits" :key="index">
            <input type="hidden" :value="ingredientMesaureUnit.conversion_grammes" :name="'ingredientMesaureUnits['+ingredientMesaureUnit.measure_unit_id+'][conversion_grammes]'">
            <div class="col-3">
                <div class="form-group">
                    <input v-model="ingredientMesaureUnit.conversion_grammes" type="text" class="form-control ">
                </div>
            </div>
            <div class="col-6">
                <div class="form-group">
                    <el-select v-model="ingredientMesaureUnit.measure_unit_id" placeholder="Unité" clearable filterable>
                        <el-option v-for="(item, index) in allMeasureUnits"
                            :key="index"
                            :label="item.name"
                            :value="item.id"
                            :disabled="isSelected(item)"
                        >
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div class="col-3">
                <el-button-group>
                    <el-button v-if="measureUnits.length" @click="addMeasureUnit" plain size="mini" type="primary" icon="el-icon-plus"></el-button>
                    <el-button @click="removeMeasureUnit(index)" v-if="index > 0" plain size="mini" type="danger"><i class="el-icon-minus"></i></el-button>
                </el-button-group>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            allMeasureUnits: [],
            ingredientMesaureUnits: []
        }
    },
    props: {
        measures: {
            default: []
        }
    },
    computed:
    {
        measureUnits()
        {
            return this.allMeasureUnits.filter( v => !this.ingredientMesaureUnits.find( vv => vv.measure_unit_id == v.id ) );
        }
    },
    created()
    {
        this.ingredientMesaureUnits = this.measures.map(v => { return { measure_unit_id: v.id, conversion_grammes: v.pivot.conversion_grammes } } )
        axios.get('/pro/measureUnits').then((d)=>{
            this.allMeasureUnits = d.data.data;
            if( !this.ingredientMesaureUnits.length ) {
                this.addMeasureUnit();
            }
        });
    },
    methods: {
        isSelected(item)
        {
            return this.ingredientMesaureUnits.find(v => v.measure_unit_id == item.id) ? true : false;
        },
        addMeasureUnit()
        {
            this.ingredientMesaureUnits.push({
                conversion_grammes: null,
                measure_unit_id: this.measureUnits[0].id
            });
        },
        removeMeasureUnit(index)
        {
            this.ingredientMesaureUnits.splice(index, 1);
        },
    }
}
</script>
<style>

</style>
